<template>
  <button type="button" class="rdk-carousel-prev" aria-label="Föregående" @click="emit('prev')" />
  <button type="button" class="rdk-carousel-next" aria-label="Nästa" @click="emit('next')" />
</template>

<script setup lang="ts">
// Styled in assets/css/carousel.css. For refresh-ui's Carousel `controls` slot.
const emit = defineEmits<{ prev: []; next: [] }>()
</script>
